module.exports = __webpack_public_path__ + "static/media/512.92b34831.jpg";